import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nameInput", "certificationSection", "calendarColorsSection"]

  connect() {
    this.toggleSections()
  }

  toggleSections() {
    if (this.hasNameInputTarget) {
      const departmentName = this.nameInputTarget.value.trim()
      const isSertifisering = departmentName === 'Sertifisering'
      
      // Show certification section only for Sertifisering
      if (this.hasCertificationSectionTarget) {
        if (isSertifisering) {
          this.certificationSectionTarget.classList.remove('d-none')
        } else {
          this.certificationSectionTarget.classList.add('d-none')
        }
      }
      
      // Hide calendar colors section for Sertifisering
      if (this.hasCalendarColorsSectionTarget) {
        if (isSertifisering) {
          this.calendarColorsSectionTarget.classList.add('d-none')
        } else {
          this.calendarColorsSectionTarget.classList.remove('d-none')
        }
      }
    }
  }

  // Keep the old method name for backward compatibility
  toggleCertificationSection() {
    this.toggleSections()
  }
}
